<template>
    <div>
        <simulationVoyageDesktop v-if="isDesktop()"></simulationVoyageDesktop>
        <simulationVoyageMobile  v-if="isMobile()"></simulationVoyageMobile>
    </div>
</template>

<script>
    import simulationVoyageDesktop from "./simulate.voyage.desktop.vue"
    import simulationVoyageMobile from "./simulate.voyage.mobile.vue"

    export default {
        name: 'AutoIndex',
        components: {
            simulationVoyageDesktop,
            simulationVoyageMobile
        },
        data() {
            return {
                
            }
        },

        methods: {
            isMobile: function () {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },
  
            isDesktop: function () {
                if (screen.width > 760) {
                    return true
                } else {
                    return false
                }
            },
        },
    }
</script>